var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWideLineTop({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1845,
    height: 329,
    viewBox: "0 0 1845 329",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M-0.5 228.5C165 337 290.473 361.07 508.5 277C744.5 186 934.503 278.519 1095.5 300.5C1366.5 337.5 1674 289 1844 0",
    stroke: "#BFB098"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWideLineTop);
export default __webpack_public_path__ + "static/media/wide-line-top.7f6b79b205cbfb5d67e346be2fd1f884.svg";
export { ForwardRef as ReactComponent };